import { Dispatch } from 'redux';
import { setErrorMessage } from '../Redux/Slices/alert.slice';
import { setFocusTo } from '../Redux/Slices/focusOnValidation.slice';

export interface ValidateFields {
  data: string | number | null;
  errorMessage: string;
  focusTo: string;
}
export const validateForm = ({
  validate,
  dispatch,
}: {
  validate: Array<ValidateFields>;
  dispatch: Dispatch;
}): boolean => {
  let isValid = true;

  for (let i = 0; i < validate.length; i++) {
    if (!validate[i].data) {
      dispatch(setErrorMessage(validate[i].errorMessage));
      dispatch(setFocusTo(validate[i].focusTo));
      isValid = false;
      break;
    }
  }
  return isValid;
};
